import { __extends, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { Icon } from '../Icon/Icon.component.js';
import { propTypes, defaultProps } from './RowButton.types.js';
import styles from './RowButton.module.scss.js';

var RowButton = /** @class */ (function (_super) {
    __extends(RowButton, _super);
    function RowButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RowButton.prototype.componentDidMount = function () {
        if (this.props.radio) {
            console.warn('DANGER: The `radio` prop was removed, change any functionality related to this prop and please use `leftElement` instead.');
        }
        if (this.props.icon) {
            console.warn('DANGER: The `icon` prop was removed, change any functionality related to this prop and please use `leftElement` instead.');
        }
        if (this.props.checkBox) {
            console.warn('DANGER: The `checkBox` prop was removed, change any functionality related to this prop and please use `leftElement` instead.');
        }
        if (this.props.checked) {
            console.warn('DANGER: The `checked` prop was removed, change any functionality related to this prop and please use `leftElement` instead.');
        }
    };
    RowButton.prototype.render = function () {
        var _a = this.props, title = _a.title, subtitle = _a.subtitle, icon = _a.icon, arrow = _a.arrow, onClick = _a.onClick, rightText = _a.rightText, disabled = _a.disabled, leftElement = _a.leftElement, className = _a.className, dataTestId = _a["data-testid"], buttonProps = _a.buttonProps;
        return (React__default.createElement("button", __assign({ type: "button", "data-testid": dataTestId, className: clsx(styles.RowButton, icon && styles.RowButton___withIcon, disabled && styles.RowButton_disabled, className), onClick: onClick, disabled: disabled }, buttonProps),
            leftElement && (React__default.createElement("div", { className: clsx(styles.RowButton_leftElement, !subtitle &&
                    styles.RowButton_leftElement___singleLine) }, leftElement)),
            React__default.createElement("div", { className: clsx(styles.RowButton_content, arrow &&
                    rightText &&
                    styles.RowButton_content___withArrow) },
                React__default.createElement("div", { className: styles.RowButton_title },
                    React__default.createElement("div", { className: clsx(styles.RowButton_titleText, styles.RowButton_titleText___ellipsis, !!subtitle &&
                            styles.RowButton_titleText___singleLine) }, title)),
                subtitle && (React__default.createElement("div", { className: styles.RowButton_subtitle }, subtitle))),
            rightText && (React__default.createElement("div", { className: clsx(styles.RowButton_textRight, arrow && styles.RowButton_textRight___withArrow, !subtitle &&
                    styles.RowButton_textRight___singleLine) }, rightText)),
            arrow && Boolean(arrow) === arrow ? (React__default.createElement("div", { className: styles.RowButton_arrow },
                React__default.createElement(Icon, { size: 28, alt: "Go to title", name: "ChevronRightIcon" }))) : (arrow)));
    };
    RowButton.propTypes = propTypes;
    RowButton.defaultProps = __assign({}, defaultProps);
    RowButton.displayName = 'RowButton';
    return RowButton;
}(React__default.Component));

export { RowButton as default };
